export default "__VITE_ASSET__ea918d64__"